// Club websites, by club id (cloudIdName). Mirrors HOST_CLUBS in the
// club-website repo (src/utils/clubHosts.ts); add a club there and here.
const CLUB_WEBSITES = {
  tfg: 'https://tfg.fangroup.io',
  score: 'https://score.fangroup.io',
  beyondskiing: 'https://beyondskiing.com',
  golf: 'https://golf.fangroup.io',
  vik: 'https://vik.fangroup.io',
  brynas: 'https://brynas.fangroup.io',
  nesso: 'https://nesso.fangroup.io',
  rosagolfen: 'https://rosagolfen.fangroup.io',
  skiljebosk: 'https://skiljebosk.fangroup.io',
  timra: 'https://timra.fangroup.io',
};

/** The club's website address, or null when it has none (or it's unknown). */
const getClubWebsite = (config) =>
  config?.websiteUrl ||
  CLUB_WEBSITES[config?.cloudIdName] ||
  CLUB_WEBSITES[config?.app_name] ||
  null;

export default getClubWebsite;
